import { lazy, Suspense } from "react";
import CabifyBanner from "./CabifyBanner";
import CabifyChoose from "./CabifyChoose";

const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));
const CabifyFeature = lazy(() => import("./CabifyFeature"));
const CabifyFeatureTwo = lazy(() => import("./CabifyFeatureTwo"));
const CabifyMinimum = lazy(() => import("./CabifyMinimum"));
const CabifyPlace = lazy(() => import("./CabifyPlace"));
const CabifySupport = lazy(() => import("./CabifySupport"));

const bannerData = {
  title: "Launch a Carpool Service with a Cabify Clone App",
  description: "Mobility Infotech offers a ready-to-launch Cabify Clone App to quickly start your branded, scalable taxi or carpooling business. Enjoy advanced features and seamless user experience for both riders and drivers.",
  image: "/assets/home/cabify-banner.webp",
  btn: "get free demo",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "cabify Clone App",
        slug: ""
      },
    ]
  }
};

const chooseData = {
  titlepart1: "Why Choose Our ",
  titlepart2: "Cabify Clone",
  titlepart3: "Script?",
  description: "Mobility Infotech’s Cabify Clone App is a ready-to-launch ride-hailing solution with real-time tracking, secure payments, and a seamless user experience—perfect for building your own taxi or carpooling business.",
  pointer1: "Quick Launch of New Ventures",
  pointer2: "User-Centric Interfaces",
  pointer3: "Advanced Features Included",
  pointer4: "On-Time Delivery Guarantee",
  pointer5: "Branded Taxi App",
  pointer6: "Full Brand Assurance",
  pointer7: "Smart Payment Integration",
  pointer8: "Fully Customizable",
  pointer9: "Cost-Effective Model",
  image: "/assets/home/cabify-choose.webp",
  backImage: "/assets/home/cabify-choose-back.webp",
};

const featureData = {
  titlePart1: "All-in-One Features",
  titlePart2: "for Customer app, Drivers app & Admins app",

  feature1: {
    image: "/assets/home/cabify-feature-1.webp",
    title1: "Instant Fare Details",
    description1: "Real-time cost estimation based on route & traffic.",
    title2: "SOS Alerts",
    description2: "Emergency contact alerts for added safety and peace of mind.",
    title3: "Ratings & Reviews",
    description3: "Transparent feedback system for both riders and drivers.",
    title4: "Smooth Profile Setup",
    description4: "Quick sign-up/login via mobile or email.",
    title5: "Live Location Tracking",
    description5: "Real-time tracking for trips and nearby vehicles.",
    title6: "Vehicle Selection Options",
    description6: "Choose from economy, premium, or pool rides.",
    title7: "Smart Trip History",
    description7: "View and manage past ride logs and receipts.",
    title8: "Multi-Stop Rides",
    description8: "Add multiple stops in one trip with ease.",
  },

  feature2: {
    image: "/assets/home/cabify-feature-2.webp",
    title1: "Trip Request Management",
    description1: "Accept or decline ride requests with a single tap based on availability.",
    title2: "Route Navigation & Optimization",
    description2: "Integrated GPS navigation with optimized routes to reduce travel time and fuel costs.",
    title3: "Earnings & Trip Summary",
    description3: "View daily, weekly, and monthly earnings along with detailed trip logs.",
    title4: "Driver Profile & Document Upload",
    description4: "Easily upload and manage licenses, vehicle papers, and ID proofs directly in the app.",
    title5: "Availability Toggle",
    description5: "Go online or offline based on driver availability in real time.",
    title6: "In-app Notifications",
    description6: "Get alerts for new trip requests, payment received, rating received, and more.",
    title7: "SOS Button",
    description7: "Built-in emergency feature for quick safety response and alert.",
    title8: "Rider Communication",
    description8: "In-app chat or call functionality to connect directly with riders.",
  },

  feature3: {
    image: "/assets/home/cabify-feature-3.webp",
    title1: "Comprehensive Dashboard",
    description1: "Access complete analytics including trips, earnings, users and drivers, in one place.",
    title2: "User & Driver Management",
    description2: "Approve new signups, suspend or remove accounts, manage ratings and documents.",
    title3: "Real-Time Trip Monitoring",
    description3: "Track all ongoing rides on the map with detailed trip status.",
    title4: "Category & Fare Control",
    description4: "Add or update vehicle types, base fare, surge pricing, and distance/time rates.",
    title5: "Reports & Analytics",
    description5: "Generate and export reports related to revenue, rides, users, and driver performance.",
    title6: "Promotions & Coupon Codes",
    description6: "Create and manage promo codes to attract more users.",
    title7: "Dispute Management",
    description7: "Handle ride issues, cancellations, and complaints efficiently.",
    title8: "Site Settings & Configurations",
    description8: "Manage app content, notifications, terms, support, and app configurations.",
  },
}

const featureTwoData = {
  titlePart1: "Highlighting the",
  titlePart2: "top features",
  btn: "More features",
  rider: {
    image1: "/assets/home/lyft-feature-rider1.webp",
    title1: "Smarter Rides, Better Comfort",
    description1: "From upfront fare estimates to multiple ways to pay, we’ve made every feature easy, efficient, and built around your ride comfort.",
    image2: "/assets/home/lyft-feature-rider2.webp",
    title2: "Get estimated trip cost",
    description2: "Know the cost before you go. Our app provides real-time fare estimates based on traffic, route, and local rates — so you can ride without the guesswork.",
    image3: "/assets/home/lyft-feature-rider3.webp",
    title3: "Contact the driver",
    description3: "Running a little late or need to clarify your pickup spot? Easily call or message your driver directly from the app for fast and clear communication.",
    image4: "/assets/home/lyft-feature-rider4.webp",
    title4: "Use multiple payment options",
    description4: "Choose what works best for you — credit/debit card, Apple Pay, Google Pay, or even PayPal. Enjoy smooth and secure checkouts every ride.",
  },
  driver: {
    image1: "/assets/home/lyft-feature-driver1.webp",
    title1: "Add payout account",
    description1: "Link one or multiple bank accounts and choose your default for receiving payouts. Fast transfers, full control, and bank-level security—your money, your way.",

    image2: "/assets/home/lyft-feature-driver2.webp",
    title2: "Cancel the trip",
    description2: "Plans changed or got a last-minute update? Cancel any trip instantly with zero hassle. We’ve made it quick, simple, and stress-free.",

    image3: "/assets/home/lyft-feature-driver3.webp",
    title3: "View earnings",
    description3: "Track your progress effortlessly. Get detailed breakdowns of your daily, weekly, and monthly earnings, so you always know where you stand.",

    image4: "/assets/home/lyft-feature-driver4.webp",
    title4: "View trip details",
    description4: "Need to revisit a ride? Access complete trip summaries including pickup and drop-off points, duration, distance, fare calculation, and more.",

    image5: "/assets/home/lyft-feature-driver5.webp",
    title5: "Add toll charges",
    description5: "Tolls? Taken care of. Add toll fees directly to the trip fare to ensure accurate billing, automated and hassle-free for every route.",
  },

  admin: {
    image1: "/assets/home/zip-feature-1.webp",
    title1: "Data Analytics",
    description1: "Drive better business decisions with real-time analytics. Monitor rider trends, driver performance, and regional activity to fine-tune operations and increase profitability.",

    image2: "/assets/home/zip-feature-admin-2.webp",
    title2: "Set Pricing",
    description2: "Customize pricing models that fit your market. Adjust fares by distance, time, zones, or peak-hour demand—all with full flexibility and accuracy.",

    image3: "/assets/home/zip-feature-admin-3.webp",
    title3: "Fleet Management",
    description3: "Manage your entire fleet from a unified dashboard. Track vehicle status, monitor driver behavior, schedule maintenance, and keep operations running smoothly across U.S. cities.",

    image4: "/assets/home/zip-feature-admin-4.webp",
    title4: "Payment Management",
    description4: "Stay in control of your finances. Oversee transactions, resolve payment issues, and ensure seamless payouts and reconciliations with built-in security and compliance tools.",

    image5: "/assets/home/zip-feature-admin-5.webp",
    title5: "Discount & Promotions",
    description5: "Attract and retain riders with targeted marketing campaigns. Easily launch promo codes, referral bonuses, first-ride discounts, and seasonal deals tailored for the U.S. market.",
  },

  fleet: {
    image1: "/assets/home/zip-feature-2.webp",
    title1: "Customer Management",
    description1: "Access a complete customer database at your fingertips. Review rider profiles, ride history, feedback, and communication—all streamlined to deliver better service.",

    image2: "/assets/home/zip-feature-fleet-2.webp",
    title2: "Cars Management",
    description2: "Take full control of your fleet. Add, update, or retire vehicles with ease while tracking availability, active status, and usage performance in real time.",

    image3: "/assets/home/zip-feature-fleet-3.webp",
    title3: "Documentation Management",
    description3: "Ensure regulatory compliance across all states. Upload, manage, and verify key documents like driver licenses, vehicle registration, and insurance—safely and securely.",

    image4: "/assets/home/zip-feature-fleet-4.webp",
    title4: "Car Maintenance",
    description4: "Minimize downtime and maximize vehicle life. Schedule regular servicing, monitor repair history, and receive proactive alerts for upcoming maintenance needs.",

    image5: "/assets/home/zip-feature-fleet-5.webp",
    title5: "Dynamic Pricing",
    description5: "Boost revenue with flexible fare strategies. Enable smart pricing that adjusts automatically based on demand surges, time of day, and geographic zones—perfectly tuned for the U.S. market.",
  },
}

const cabifyPlaceData = {
  titlePart1: "Manage your business,",
  titlePart2: "in one place",
  btn: "more features",
  tab1: {
    title: "View a consolidated dashboard",
    description: "Access a unified dashboard showcasing platform insights, user metrics, and operational performance at a glance.",
    image: "/assets/home/lyft-place-1.webp",
  },
  tab2: {
    title: "Manage site-wide settings",
    description: "Control and customize the application's platform preferences, branding elements, and functional settings.",
    image: "/assets/home/lyft-place-2.webp",
  },
  tab3: {
    title: "Add & update vehicle categories",
    description: "Create and modify vehicle types with detailed specifications, pricing, and availability settings for seamless fleet management.",
    image: "/assets/home/lyft-place-3.webp",
  },
  tab4: {
    title: "Full site configuration options",
    description: "Fine-tune backend functionalities, user roles, payment gateways, and app behavior through comprehensive configuration tools.",
    image: "/assets/home/lyft-place-4.webp",
  },
  tab5: {
    title: "Add cancelation reasons & policies",
    description: "Define and manage cancellation reasons to enhance clarity, reduce disputes, and maintain platform transparency.",
    image: "/assets/home/lyft-place-5.webp",
  },
  tab6: {
    title: "Manage Fare Structures",
    description: "Create, modify, and assign fare rules based on vehicle type, distance, duration, base fare, surge pricing, and more—full flexibility to match your business model.",
    image: "/assets/home/lyft-place-6.webp",
  },
  tab7: {
    title: "Manage payout",
    description: "Oversee driver and partner earnings with secure and transparent payout processing. Set payout schedules, manage linked accounts, and monitor transaction history effortlessly.",
    image: "/assets/home/lyft-place-7.webp",
  },
  tab8: {
    title: "Set Promo Codes & Offers",
    description: "Drive user acquisition and retention with customizable promo codes. Define usage limits, discount types, validity periods, and user eligibility for every campaign.",
    image: "/assets/home/lyft-place-8.webp",
  },
}

const cabifyMinimumData = {
  tagline: "Why Quality Outshines Cost",
  titlePart1: "Think beyond",
  titlePart2: "Minimum Viable Product",
  description: "Launch with Mobility Infotech’s Cabify Clone – engineered for limitless scalability and long-term success.",
  box1: {
    image: "/assets/home/lyft-minimum-1.webp",
    title: "Gain Full Ownership with 100% Unencrypted Source Code",
  },
  box2: {
    image: "/assets/home/lyft-minimum-2.webp",
    title: "Unlock Premium Features — Even in the Base Package",
  },
  box3: {
    image: "/assets/home/lyft-minimum-3.webp",
    title: "Receive Unlimited Updates at Zero Additional Cost",
  },
  box4: {
    image: "/assets/home/lyft-minimum-4.webp",
    title: "Deliver a World-Class Experience with Elegant UI/UX",
  },
  box5: {
    image: "/assets/home/lyft-minimum-5.webp",
    title: "Access Industry-Leading Post-Deployment Support",
  },
  box6: {
    image: "/assets/home/lyft-minimum-6.webp",
    title: "Optimized for High Performance and Reliability",
  },
  btn: "SEE OUR PRICING PLAN",
}

const cabifySupportData = {
  titlePart1: "Free support, no",
  titlePart2: "additional charge",
  box1: {
    image: "/assets/home/lyft-support-1.webp",
    title: "White-labeling",
    description: "Your logo, brand colors, and name across all apps",
  },
  box2: {
    image: "/assets/home/lyft-support-2.webp",
    title: "Server installation",
    description: "We configure everything on your preferred server",
  },
  box3: {
    image: "/assets/home/lyft-support-3.webp",
    title: "App Store Submission",
    description: "Guidance & submission for Android & iOS",
  },
  box4: {
    image: "/assets/home/lyft-support-4.webp",
    title: "App rejection support",
    description: "Full assistance to resolve submission issues",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is the Cabify Clone App by Mobility Infotech?",
    answer: "The Cabify Clone App is a fully customizable, ready-to-deploy taxi and carpooling app solution that helps you launch your ride-hailing business quickly and efficiently. It’s packed with advanced features for riders, drivers, admins, and fleet managers.",
  },
  {
    id: "1",
    question: "02. Can I launch this app under my own brand name?",
    answer: "Absolutely. We offer a 100% white-label solution, meaning the app will reflect your branding, including logo, brand colors, name, and identity across all user interfaces.",
  },
  {
    id: "2",
    question: "03. Do I get access to the full source code?",
    answer: "Yes, you receive 100% unencrypted source code, ensuring complete ownership and the freedom to customize or scale as your business grows.",
  },
  {
    id: "3",
    question: "04. How long does it take to launch the app?",
    answer: "Our turnkey Cabify Clone App can be deployed in record time. With all configurations in place, your branded app can go live within just a few days, depending on custom requirements.",
  },
  {
    id: "4",
    question: "05. What platforms does the app support?",
    answer: "The solution is compatible with both Android and iOS platforms. We also provide a powerful admin panel for web-based operations.",
  },
  {
    id: "5",
    question: "06. What type of businesses can use this app?",
    answer: "This app is ideal for taxi services, carpooling businesses, fleet management providers, and entrepreneurs looking to enter the mobility-as-a-service industry.",
  },
];

export default function CabifyClone() {
  return (
    <>
      <CabifyBanner data={bannerData} />
      <CabifyChoose data={chooseData} />

      <Suspense fallback={null}>
        <CabifyFeature data={featureData} />
        <CabifyFeatureTwo data={featureTwoData} />
        <CabifyPlace data={cabifyPlaceData} />
        <CabifyMinimum data={cabifyMinimumData} />
        <CabifySupport data={cabifySupportData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
